//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const sizeClasses = {
  extralarge: 'text-4xl sm:text-6xl',
  large: 'text-4xl',
  mediumlarge: 'text-2xl',
  medium: 'text-xl',
  small: 'text-base',
  extrasmall: 'text-sm',
  auto: ''
}
const paddingClasses = {
  none: '',
  left: 'pl-2',
  right: 'pl-2'
}

export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'small'
    },
    padding: {
      type: String,
      required: false,
      default: 'none'
    },
    bold: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    sizeClass() {
      return sizeClasses[this.size]
    },
    paddingClass() {
      return paddingClasses[this.padding]
    }
  }
}
